import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ICurrentWorkspaceStore } from '../../../../modules/workspaces/currentWorkspace/CurrentWorkspace.store';
import { ImageUploadModal } from '../components/ImageUploadModal';
import { DatasetDetails } from '../DatasetDetails.context';
import { IUpdateDatasetService } from '../updateDataset.service';
import { IUpdateDatasetFilesService } from '../updateDatasetFiles.service';

export const UpdateDatasetContainer = observer((): ReactElement => {
  const updateDatasetService = useInjection(IUpdateDatasetService.$);
  const updateDatasetFilesService = useInjection(IUpdateDatasetFilesService.$);
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);
  const datasetDetailsContext = useContext(DatasetDetails);

  const context = useContext(DatasetDetails);

  const { datasetId } = useParams<{ datasetId: string }>();
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    updateDatasetFilesService.setup(context.store);
  }, []);

  const handleUploadImagesAsync = async (): Promise<void> => {
    setIsConfirmationModalOpen(false);
    setIsModalOpen(false);
    await updateDatasetService.uploadImages(datasetId);
  };

  const handleToggleUploadConfirmationModal = (): void => {
    setIsConfirmationModalOpen((prevState) => !prevState);
  };

  const handleToggleUploadModal = (): void => {
    setIsModalOpen((prevState) => !prevState);
  };

  const store = context.store;
  const imagesRejectedFromFile = store.imagesRejectedFromFile;
  const imagesToUploadFromFile = store.imagesToUploadFromFile;

  return (
    <ImageUploadModal
      isCancelEnabled={true}
      datasetId={datasetId}
      imagesRejectedFromFile={imagesRejectedFromFile}
      imagesToUploadFromFile={imagesToUploadFromFile}
      datasetStatus={store.details.status}
      isCreationEnabled={imagesToUploadFromFile.length > 0 && !store.willExceedsUploadImageSizeLimit}
      onFormSubmit={handleUploadImagesAsync}
      isProcessingImages={updateDatasetFilesService.isProcessingImages}
      addImagesToDataset={updateDatasetFilesService.addImagesToDataset}
      cleanImagesFromFile={updateDatasetFilesService.cleanImagesFromFile}
      willExceedsUploadImageSizeLimit={store.willExceedsUploadImageSizeLimit}
      imagePreValidationWasSuccessful={store.imagePreValidationWasSuccessful}
      ownerPlan={store.ownerPlan}
      toggleUploadConfirmationModal={handleToggleUploadConfirmationModal}
      isConfirmationModalOpen={isConfirmationModalOpen}
      showModal={isModalOpen}
      toggleUploadModal={handleToggleUploadModal}
      isEncryptionEnabled={currentWorkspaceStore.currentWorkspace.encryption.encrypted || false}
      datasetCreatorId={store.details.createdById}
      currentFilesSizeInB={datasetDetailsContext.store.details.imagesSize * 1024 * 1024}
    />
  );
});
